import thirdPartyLoader from '../helpers/third-party-loader';

const iframes = {
  elements: {
    iframes: Array.from(document.querySelectorAll('.curtis-text iframe')) as HTMLIFrameElement[],
    videos: [] as HTMLIFrameElement[]
  },

  init() {
    this.elements.videos = Array.from(this.elements.iframes).filter(iframe => {
      // Ensure iframe has a valid src attribute
      if (!iframe.src) return false;
      
      const src = iframe.src.toLowerCase();
      return src.includes('youtube.com') ||
             src.includes('vimeo.com') ||
             src.includes('dailymotion.com') ||
             src.includes('video');
    });

    this.bindEvents();
  },

  bindEvents() {
    if(!this.elements.videos.length) return;

    this.elements.videos.forEach((iframe) => {
      this.wrap(iframe);
      
      // Safely initialize Vimeo players
      if (thirdPartyLoader.isVimeoEmbed(iframe.src)) {
        thirdPartyLoader.loadVimeoPlayer(iframe).catch(error => {
          console.warn('Failed to initialize Vimeo player:', error);
        });
      }
    });
  },

  wrap(element: Element) {
    if(!element || !element.parentNode) return;

    try {
      // Check if element is already wrapped
      if (element.parentElement?.classList.contains('iframe-wrapper')) return;

      const wrapper = document.createElement('div');
      wrapper.classList.add('iframe-wrapper');
      element.parentNode.insertBefore(wrapper, element);
      wrapper.appendChild(element);
    } catch (error) {
      console.warn('Error wrapping iframe:', error);
    }
  }
};

export default iframes;
